import type {
	WebhookAction,
	WebhookDeliveryStatus,
	WebhookStatus,
} from "@/common/model";
import { createStatusBadge, type TagStatus } from "../status-pill";

export const WebhookActionLabelMap: Record<WebhookAction, string> = {
	CREATE_TASK: "Create & start task",
	DISCOVER_DEPLOYMENT: "Discover deployment",
};

export const WebhookStatusBadge = createStatusBadge<WebhookStatus>(
	{ ENABLED: "success", DISABLED: "default" },
	{ ENABLED: "Enabled", DISABLED: "Disabled" },
);

export const WebhookDeliveryStatusColorMap: Record<
	WebhookDeliveryStatus,
	TagStatus
> = {
	SUCCEEDED: "success",
	COALESCED: "processing",
	FAILED: "error",
};

export const WebhookDeliveryStatusBadge = createStatusBadge(
	WebhookDeliveryStatusColorMap,
	{
		SUCCEEDED: "Succeeded",
		COALESCED: "Already running",
		FAILED: "Failed",
	},
);
